const cartPopupOpenTrigger = $('[data-cart-popup-open]');
const cartPopup = $('aside.cart-popup-section');
const cartPopupBg = $('[data-popup-bg]');

$(function () {
	cartQtyUpdate();
	loginCheck();
	loginCheckMobile();
});



///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CART POPUP

cartPopupOpenTrigger.on('click', function() {
	cartPopupShow();
});


$(document).on('click', '[data-cart-popup-close]', async function(e) {
	cartPopupHide();
});


$(document).on('click', function(e) {
    if (!cartPopupOpenTrigger.is(e.target) && cartPopupOpenTrigger.has(e.target).length === 0 && !cartPopup.is(e.target) && cartPopup.has(e.target).length === 0) {
        cartPopupHide();
    }
});

async function cartPopupShow() {
    try {
        await updateCartContent();
        cartPopup.attr('data-revealed', 'true');
        cartPopupBg.attr('data-revealed', 'true');
        $('body').attr('data-popup-expanded', 'true');
    } catch (error) {
        console.error('Error updating cart content:', error);
    }
}


async function updateCartContent() {
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/dynamic/cart',
			type: 'GET',
			dataType: 'html',
			success: function(response) {
				$('aside.cart-popup-section').html(response);
				resolve();
			},
			error: function(xhr, status, error) {
				console.error('Failed to fetch cart content:', error);
				reject(error);
			}
		});
	});
}


function cartPopupHide() {
	cartPopup.attr('data-revealed', 'false');
	cartPopupBg.attr('data-revealed', 'false');
	$('body').attr('data-popup-expanded', 'false');
}

async function cartQtyUpdate() {
	try {
		const response = await fetch('/actions/commerce/cart/get-cart', {
			headers: {
				'Accept': 'application/json',
			},
		});
		const data = await response.json();
		// console.log('cartQtyUpdate ' + data.cart.totalQty);
		$('[data-cart-items]').attr('data-cart-items', data.cart.totalQty);
		$('[data-cart-items]').text(data.cart.totalQty);
	} catch (error) {
		console.error('Error updating cart quantity:', error);
	}
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// PRODUCT QTY

function incrementValue(e) {
    e.preventDefault();
    var fieldClass = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find('.' + fieldClass).val(), 10);
    var newVal = currentVal;
	var maxValue = parent.find('.' + fieldClass).attr('data-qty-max');

    if (!isNaN(currentVal)) {
		newVal = currentVal + 1;
    } else {
        newVal = 1;
    }
	console.log('newVal 1 ' + newVal)
	parent.find('.' + fieldClass).val(newVal);
	parent.find('.' + fieldClass).trigger('change');

	if (newVal > maxValue) {
		newVal = maxValue;
		setTimeout(() => {
			parent.find('.' + fieldClass).val(newVal);
		}, 500);
	}
	// console.log('newVal 2 ' + newVal)
	
}

function decrementValue(e) {
    e.preventDefault();
    var fieldClass = $(e.target).data('field');
    var parent = $(e.target).closest('div');
    var currentVal = parseInt(parent.find('.' + fieldClass).val(), 10);
	var newVal = currentVal;
	var maxValue = parent.find('.' + fieldClass).attr('data-qty-max');

    if (!isNaN(currentVal) && currentVal > 0 && currentVal-1 > -1) {
		newVal = currentVal - 1;
    } else {
        newVal = 1;
    }

	parent.find('.' + fieldClass).val(newVal);
	parent.find('.' + fieldClass).trigger('change');
}

$(document).on('click', '.qty-plus', function(e) {
    incrementValue(e);
});

$(document).on('click', '.qty-minus', function(e) {
    decrementValue(e);
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// LOGIN CHECK

async function loginCheckMobile() {
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/dynamic/login-mobile',
			type: 'GET',
			dataType: 'html',
			success: function(response) {
				$('.mobile-menu .column-login a').text(response);
				resolve();
			},
			error: function(xhr, status, error) {
				console.error('Failed to fetch login content:', error);
				reject(error);
			}
		});
	});
}

async function loginCheck() {
	return new Promise((resolve, reject) => {
		$.ajax({
			url: '/dynamic/login',
			type: 'GET',
			dataType: 'html',
			success: function(response) {
				$('header .login-block').html(response);
				resolve();
			},
			error: function(xhr, status, error) {
				console.error('Failed to fetch login content:', error);
				reject(error);
			}
		});
	});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ADD TO CART

$(function () {
	var productEl = $('[data-product-id]');
	if (productEl.length) {
		productEl.each(async function() {
			var productId = $(this).attr('data-product-id');
			checkStock(productId);
		})
	}	
})

/**
 * CHECK STOCK - SHOP
 * Similar to function in Account.js, please update that as well.
 */
window.checkStock = async function checkStock(productId) {

    // console.log('CHECK STOCK for ' + productId)

    var requestURL = siteUrl + '/product/' + productId + '.json';

    // console.log('Fetching STOCK data...');
    // console.log(requestURL)

    try {
        const response = await $.ajax({
            type: 'get',
            url: requestURL,
        });
		
		if (!response.data[0]) return false;
        // console.log(response.data[0]);
		
		var el = $('[data-product-id="' + productId + '"]');

		var stock = response.data[0].stock;
		var onSale = response.data[0].onSale;
		var salePriceAsCurrency = response.data[0].salePriceAsCurrency;
		var priceAsCurrency = response.data[0].priceAsCurrency;

		if (stock <= 0) {
			el.find('.price').replaceWith('<p class="out-of-stock">Out of stock</p>');
			el.find('form').remove();
		}
		if (onSale) {
			el.find('.price').html(salePriceAsCurrency + ' <del>' + priceAsCurrency + '</del>');
		} else {
			el.find('.price').html(salePriceAsCurrency);
		}

    } catch (error) {
        console.log('Error fetching STOCK data');
        console.log(error);
    }

    return true;

}

$(document).on('change', '.qty-input[data-refresh-cart="true"]', async function(e) {
	console.log('CHANGED QTY ' + $(this).val())
	// addToCart($(this), 'cart');
	$(this).closest('form').trigger('submit');
});

$(document).on('submit', 'form.cart-update', async function(e) {
	e.preventDefault();
	addToCart($(this));
});

function addToCart(form) {
	console.log('ADD TO CART')
    fetch('/actions/blitz/csrf/token')
		.then(response => response.text())
		.then(csrfToken => {
			console.log(csrfToken);
			var addToCartButton = form.find('[data-add-to-cart-button]');
			addToCartButton.text('One moment...');
			var errorMessageEl = form.find('.cart-message');
			var errorMessage = '';

			var refreshPage = addToCartButton.attr('data-add-to-cart-refresh') == 'true' ? true : false

			var data = form.serialize();
			data['CRAFT_CSRF_TOKEN'] = csrfToken;

			$.ajax({
				url: '/commerce/cart/update-cart',
				type: 'post',
				data: data,
				success: function(response) {
					console.log(response);
					console.log(response.message);
					addToCartButton.text(response.message);
					setTimeout(() => {
						addToCartButton.text('Add to cart');
					}, 1500);
					if (refreshPage) {
						location.reload();
					}
					cartQtyUpdate();
					cartPopupShow();
					errorMessageEl.text(errorMessage);
				},
				error: function (response) {
					console.log('Error');
					console.log(response);
                    console.log('Status:', response.status);
                    console.log('Status Text:', response.statusText);
                    console.log('Response Text:', response.responseText);
					try {
                        var response = JSON.parse(response.responseText);
                        if (response.message) {
							errorMessage = errorMessage + response.message + ' ';
                        }
						for (var key in response.errors) {
							if (response.errors.hasOwnProperty(key)) {
								response.errors[key].forEach(function(error) {
									errorMessage = errorMessage + error + ' ';
								});
							}
						}
                        if (errorMessage.length) {
                            console.log('errorMessage:', errorMessage);
							errorMessageEl.text(errorMessage);
                        }
                    } catch (e) {
                        console.error('Failed to parse JSON response:', e);
                    }
				},
				dataType: 'json'
			});
		})
		.catch(error => {
			console.error('Error fetching CSRF token:', error);
		});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// CART PAGE

$(document).on('click', '[data-shop-item-remove]', function(e) {
	console.log('data-shop-item-remove')
	$(this).parent().find('input[type="checkbox"]').prop('checked', true);
	$(this).closest('form').trigger('submit');
});


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////




///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// DISCOUNT POPUP

$(document).on('submit', 'form[data-form-discount-popup]', async function(e) {
	e.preventDefault();
	addDiscount($(this));
});

function addDiscount(form) {
	console.log('ADD DISCOUNT')
	var errorBox = form.find('.popup-error');
	var button = form.find('button');
	errorBox.text('');
    fetch('/actions/blitz/csrf/token')
		.then(response => response.text())
		.then(csrfToken => {
			console.log(csrfToken);
			button.text('One moment...');
			var successBox = form.find('.popup-success');
			successBox.text('');
			var data = form.serialize();
			data['CRAFT_CSRF_TOKEN'] = csrfToken;


			return $.ajax({
				type: 'post',
				url: '/imagiccms?p=actions/order/order/create-discount',
				data: data,
				success: function (response) {
					console.log('Done');
					console.log(response);
					if (response.success) {
						form.addClass('hide-form');
						successBox.text(response.message);
						form.closest('aside').find('.description-bottom + [data-promo-popup-close]').text('Close');
					} else {
						errorBox.text(response.message);
					}
					button.text('Get it now!');
				},
				error: function (response) {
					errorBox.text('Something went wrong, please try again.');
					button.text('Get it now!');
					console.log('Error');
					console.log(response);
				}
			});
		})
		.catch(error => {
			errorBox.text('Something went wrong, please try again.');
			button.text('Get it now!');
			console.error('Error fetching CSRF token:', error);
		});
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
